// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Matches incyia-ux-proposal.html table + sticky first column */
.incyia-table-wrap {
  overflow: auto;
  width: 100%;
  max-height: min(520px, calc(100vh - 340px));
  overscroll-behavior: contain;
}

.incyia-table-wrap::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}

.incyia-table-wrap::-webkit-scrollbar-thumb {
  background: #c5d0d6;
  border-radius: 99px;
}

.incyia-table-wrap::-webkit-scrollbar-track {
  background: #f0f4f5;
}

.incyia-table {
  width: 100%;
  border-collapse: collapse;
  white-space: nowrap;
  font-family: Lato, sans-serif;
}

.incyia-table thead th {
  font-size: 15px;
  font-weight: 600;
  letter-spacing: 0.12em;
  text-transform: uppercase;
  color: #8a9ba7;
  text-align: left;
  padding: 12px 16px;
  background: #f7fafa;
  border-bottom: 1px solid #dfe7e8;
  position: sticky;
  top: 0;
  z-index: 2;
}

.incyia-table thead th:first-child {
  position: sticky;
  left: 0;
  z-index: 4;
  background: #f7fafa;
  min-width: 160px;
  max-width: 220px;
  width: 220px;
  white-space: nowrap;
  box-shadow: 4px 0 8px -6px rgba(6, 21, 36, 0.25);
}

.incyia-table tbody td {
  padding: 14px 16px;
  border-bottom: 1px solid #eaf0f0;
  font-size: 16px;
  vertical-align: middle;
  color: #0b1e2d;
  background: #fff;
}

.incyia-table tbody tr {
  transition: background 0.12s;
  cursor: pointer;
}

.incyia-table tbody tr:hover {
  background: #f7fafa;
}

.incyia-table tbody tr:hover td {
  background: #f7fafa;
}

.incyia-table tbody tr:hover td:first-child {
  background: #f7fafa;
}

.incyia-table tbody td:first-child,
.incyia-table tbody td.incyia-col-pinned {
  position: sticky;
  left: 0;
  z-index: 3;
  background: #fff;
  font-weight: 500;
  min-width: 160px;
  max-width: 220px;
  width: 220px;
  overflow: hidden;
  white-space: normal;
  word-break: break-word;
  box-shadow: 4px 0 8px -6px rgba(6, 21, 36, 0.25);
  cursor: pointer;
}

.incyia-table tbody tr:last-child td {
  border-bottom: none;
}

.incyia-table td.incyia-wrap {
  white-space: normal;
  min-width: 200px;
  max-width: 320px;
  color: #5f7484;
  line-height: 1.45;
  vertical-align: middle;
}

/* Text preview — 2 lines, full text via title tooltip (Label, Description, etc.) */
.incyia-desc {
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  line-clamp: 2;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: normal;
  word-break: break-word;
  max-width: 320px;
  min-width: 0;
  color: #5f7484;
  font-size: 16px;
  line-height: 1.45;
  cursor: help;
}

.incyia-desc[data-lines='3'] {
  -webkit-line-clamp: 3;
  line-clamp: 3;
}

.incyia-desc.is-empty {
  cursor: default;
  color: #8a9ba7;
}

.incyia-desc--primary {
  color: #0b1e2d;
  font-weight: 500;
  font-size: 16px;
  line-height: 1.35;
  max-width: 100%;
  cursor: help;
}

.incyia-desc--primary.is-empty {
  cursor: default;
}

.incyia-desc--sub {
  color: #8a9ba7;
  font-size: 15px;
  font-weight: 400;
  line-height: 1.35;
  max-width: 100%;
  cursor: help;
}

.incyia-col-pinned .incyia-desc,
.incyia-wrap .incyia-desc,
.incyia-muted .incyia-desc {
  max-width: 100%;
  min-width: 0;
}

.incyia-table td.incyia-muted {
  color: #5f7484;
  max-width: 220px;
  white-space: normal;
  vertical-align: middle;
}

.incyia-name-link {
  color: #00146d;
  font-weight: 500;
  font-size: 16px;
  text-decoration: none;
  display: inline;
  max-width: 100%;
  min-width: 0;
  line-height: 1.35;
  cursor: pointer;
  transition: color 0.14s;
}

.incyia-name-link:hover,
.incyia-table tbody tr:hover .incyia-name-link {
  color: #076b5c;
}

.incyia-name-link:hover .incyia-desc,
.incyia-name-link:hover .incyia-desc--primary,
.incyia-table tbody tr:hover .incyia-name-link .incyia-desc,
.incyia-table tbody tr:hover .incyia-name-link .incyia-desc--primary {
  text-decoration: underline;
  text-underline-offset: 3px;
  text-decoration-thickness: 1px;
}

.incyia-table tbody tr:hover .incyia-family-label .incyia-desc--primary {
  color: #076b5c;
}

.incyia-name-link .incyia-desc,
.incyia-name-link .incyia-desc--primary {
  color: inherit;
  font-weight: inherit;
  font-size: inherit;
  max-width: 100%;
  width: fit-content;
  cursor: pointer;
  text-decoration: none;
}

.incyia-family-label {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 2px;
  text-decoration: none;
  min-width: 0;
  max-width: 100%;
  overflow: hidden;
  cursor: pointer;
}

.incyia-family-label .incyia-desc--primary {
  text-decoration: none;
  color: #00146d;
  cursor: pointer;
  transition: color 0.14s;
}

.incyia-family-label:hover .incyia-desc--primary {
  color: #076b5c;
  text-decoration: underline;
  text-underline-offset: 3px;
  text-decoration-thickness: 1px;
}

.incyia-family-code {
  color: #0e8271;
  font-weight: 500;
  font-size: 17px;
  font-family: 'IBM Plex Mono', ui-monospace, monospace !important;
  font-variant-numeric: tabular-nums;
  line-height: 1.2;
  max-width: 100%;
  letter-spacing: -0.01em;
}

.incyia-family-label .incyia-desc--sub {
  color: #8b99b4;
  font-size: 14.5px;
  font-weight: 400;
  margin-top: 2px;
  text-decoration: none;
}

.incyia-family-label:hover .incyia-desc--sub,
.incyia-table tbody tr:hover .incyia-family-label .incyia-desc--sub,
.incyia-table tbody tr:hover .incyia-family-label .incyia-family-code,
.incyia-family-label:hover .incyia-family-code {
  color: #8b99b4;
  text-decoration: none;
}

.incyia-table tbody tr:hover .incyia-family-label .incyia-family-code,
.incyia-family-label:hover .incyia-family-code {
  color: #0e8271;
}

.incyia-score {
  font-family: 'IBM Plex Mono', ui-monospace, monospace !important;
  font-size: 16px;
  font-weight: 500;
  font-variant-numeric: tabular-nums;
  color: #0f172a;
}

/* Families list: four even lanes so Source is not stranded
   in a gap and Score is not stuck to Actions. */
.incyia-table--families {
  table-layout: fixed;
}

.incyia-table--families thead th:first-child,
.incyia-table--families tbody td:first-child,
.incyia-table--families tbody td.incyia-col-pinned {
  width: 44%;
  min-width: 0;
  max-width: none;
  white-space: nowrap;
  word-break: normal;
  box-shadow: none;
}

.incyia-table--families th:nth-child(2),
.incyia-table--families td:nth-child(2) {
  width: 24%;
  white-space: nowrap;
}

.incyia-table--families th:nth-child(3),
.incyia-table--families td:nth-child(3) {
  width: 18%;
  white-space: nowrap;
}

.incyia-table--families th:nth-child(4),
.incyia-table--families td:nth-child(4) {
  width: 14%;
  white-space: nowrap;
}

.incyia-family-name {
  display: block;
  max-width: 56ch;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  margin-top: 3px;
  color: #5b6b87;
  font-size: 16px;
  font-weight: 400;
  line-height: 1.35;
}

.incyia-family-source {
  color: #5b6b87;
  font-weight: 400;
}

.incyia-table--families .incyia-family-code,
.incyia-table--families .incyia-family-name,
.incyia-table--families .incyia-family-source,
.incyia-table--families .incyia-score,
.incyia-table--families .incyia-money,
.incyia-table--families .incyia-desc,
.incyia-table--families .incyia-desc--primary,
.incyia-table--families .incyia-desc--sub,
.incyia-table--families .mapping-flow-row-cta,
.incyia-table--families .mapping-flow-row-cta-label,
.incyia-table--controls .incyia-family-code,
.incyia-table--controls .incyia-family-name,
.incyia-table--controls .incyia-family-source,
.incyia-table--controls .incyia-desc,
.incyia-table--controls .incyia-desc--primary,
.incyia-table--controls .incyia-desc--sub,
.incyia-table--controls .mapping-flow-row-cta,
.incyia-table--controls .mapping-flow-row-cta-label {
  font-size: 16px;
}

/* Controls list: the description is the reading column.
   The label stays a code plus one line, not a wrapped title. */
.incyia-table--controls {
  table-layout: fixed;
}

.incyia-table--controls thead th:first-child,
.incyia-table--controls tbody td:first-child,
.incyia-table--controls tbody td.incyia-col-pinned {
  width: 26%;
  min-width: 0;
  max-width: none;
  white-space: nowrap;
  word-break: normal;
  box-shadow: none;
}

.incyia-table--controls th:nth-child(2),
.incyia-table--controls td:nth-child(2),
.incyia-table--controls td.incyia-wrap {
  width: 44%;
  max-width: none;
  white-space: normal;
}

.incyia-table--controls .incyia-desc {
  max-width: none;
  color: #5b6b87;
}

.incyia-table--controls th:nth-child(3),
.incyia-table--controls td:nth-child(3) {
  width: 14%;
  white-space: nowrap;
}

.incyia-table--controls th:nth-child(4),
.incyia-table--controls td:nth-child(4) {
  width: 16%;
  white-space: nowrap;
}

.incyia-table--controls .incyia-row-actions {
  opacity: 1;
}

.incyia-table--families .incyia-row-actions {
  opacity: 1;
}

.incyia-cell-sub {
  display: block;
  font-size: 15px;
  color: #8a9ba7;
  font-weight: 400;
  margin-top: 1px;
  line-height: 1.4;
  white-space: normal;
  font-family: Lato, sans-serif;
}

.incyia-money,
.incyia-num {
  white-space: nowrap;
  font-variant-numeric: tabular-nums;
}

td:has(> .incyia-money),
td:has(> .incyia-num),
td.incyia-num,
th.incyia-num,
.MuiDataGrid-cell.incyia-num {
  text-align: left;
  white-space: nowrap;
}

th.incyia-num > * {
  justify-content: flex-start;
}

.incyia-money {
  font-family: 'IBM Plex Mono', ui-monospace, monospace !important;
  font-size: 16px;
  font-weight: 500;
  font-variant-numeric: tabular-nums;
  color: #0f172a;
}

/* The date is the only thing in the cell. A normal line box keeps a
   descender gap under the baseline, so the icon and the date sit high
   in a short row and drop when the row grows. */
.incyia-table tbody td:has(> .incyia-date-cell),
.detail-table tbody td:has(> .incyia-date-cell) {
  line-height: 0;
  vertical-align: middle;
}

.MuiDataGrid-cell:has(> .incyia-date-cell),
.detail-info-val:has(> .incyia-date-cell) {
  display: flex !important;
  align-items: center !important;
  line-height: 1 !important;
}

.incyia-date-cell {
  display: inline-flex;
  align-items: center;
  vertical-align: middle;
  gap: 7px;
  font-size: 16px;
  font-weight: 500;
  font-variant-numeric: tabular-nums;
  color: #5b6b87;
  white-space: nowrap;
  line-height: 1;
}

.incyia-date-text {
  display: block;
  line-height: 1;
}

.incyia-date-cell[title] {
  cursor: help;
}

.incyia-date-cell.is-empty {
  color: #8a9ba7;
}

.incyia-date-cell svg {
  display: block;
  width: 14px;
  height: 14px;
  flex: 0 0 14px;
  opacity: 0.6;
}

.incyia-pill {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  font-size: 15px;
  font-weight: 500;
  padding: 3px 9px;
  border-radius: 99px;
  white-space: nowrap;
  font-family: Lato, sans-serif;
  line-height: 1;
  vertical-align: middle;
}

.incyia-pill--sm {
  font-size: 15px;
  font-weight: 600;
  padding: 2px 7px;
  gap: 4px;
}

.incyia-pill--body {
  font-size: 15px;
  font-weight: 500;
  padding: 5px 11px;
  gap: 6px;
}

.incyia-pill--body .incyia-pill-dot {
  width: 6px;
  height: 6px;
}

.incyia-pill-dot {
  width: 5px;
  height: 5px;
  border-radius: 99px;
  background: currentColor;
  flex-shrink: 0;
  display: block;
  align-self: center;
}

.incyia-pill--sm .incyia-pill-dot {
  width: 4px;
  height: 4px;
}

.incyia-row-actions {
  display: inline-flex;
  gap: 8px;
  align-items: center;
  justify-content: flex-end;
  flex-wrap: wrap;
  opacity: 0.55;
  transition: opacity 0.14s;
}

.incyia-table tbody tr:hover .incyia-row-actions {
  opacity: 1;
}

/* Labeled row CTAs — always readable (icons alone are not enough) */
.incyia-row-actions--labeled {
  opacity: 1;
  gap: 6px;
}

.incyia-row-action-btn {
  appearance: none;
  display: inline-flex;
  align-items: center;
  gap: 4px;
  height: 28px;
  padding: 0 10px;
  border-radius: 7px;
  border: 1px solid #dfe7e8;
  background: #fff;
  color: #076b5c;
  font-family: Lato, sans-serif;
  font-size: 16px;
  font-weight: 700;
  letter-spacing: 0.01em;
  white-space: nowrap;
  cursor: pointer;
  transition: background 0.14s, border-color 0.14s, color 0.14s;
}

.incyia-row-action-btn:hover {
  background: #f0faf8;
  border-color: #c5e4dc;
  color: #055447;
}

.incyia-row-action-btn--ghost {
  color: #5f7484;
  font-weight: 600;
}

.incyia-row-action-btn--ghost:hover {
  color: #0b1e2d;
  background: #f7fafa;
  border-color: #8a9ba7;
}

@media (max-width: 900px) {
  .incyia-row-action-btn .incyia-row-action-full {
    display: none;
  }
}

@media (min-width: 901px) {
  .incyia-row-action-btn .incyia-row-action-short {
    display: none;
  }
}

.incyia-table-empty {
  padding: 0;
  text-align: center;
  color: inherit;
  font-size: inherit;
  font-family: Lato, sans-serif;
}

.incyia-sla {
  display: inline-flex;
  flex-direction: column;
  align-items: flex-start;
  font-family: 'IBM Plex Mono', ui-monospace, monospace !important;
  font-size: 16px;
  font-variant-numeric: tabular-nums;
  color: #0b1e2d;
  line-height: 1.15;
}

.incyia-sla-sub {
  display: block;
  font-size: 15px;
  color: #8a9ba7;
  font-weight: 400;
  margin-top: 2px;
  font-family: Lato, sans-serif;
  white-space: nowrap;
}

/* Inline entity attach (pipeline / project) inside list tables */
.entity-selector {
  width: 100%;
  min-width: 148px;
  max-width: 220px;
  position: relative;
}

.entity-selector-link {
  display: inline;
  max-width: 100%;
  color: #00146d;
  font-weight: 500;
  font-size: 16px;
  font-family: Lato, sans-serif;
  text-decoration: none;
  line-height: 1.35;
  transition: color 0.14s;
}

.entity-selector-link:hover {
  color: #076b5c;
  text-decoration: underline;
  text-underline-offset: 3px;
}

.entity-selector-loading {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  font-size: 16px;
  color: #5f7484;
  font-family: Lato, sans-serif;
}

.entity-select__menu {
  min-width: 180px;
}

`, "",{"version":3,"sources":["webpack://./src/components/common/ListPageTable.css"],"names":[],"mappings":"AAAA,gEAAgE;AAChE;EACE,cAAc;EACd,WAAW;EACX,2CAA2C;EAC3C,4BAA4B;AAC9B;;AAEA;EACE,UAAU;EACV,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,mBAAmB;EACnB,6BAA6B;AAC/B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,gCAAgC;EAChC,gBAAgB;EAChB,MAAM;EACN,UAAU;AACZ;;AAEA;EACE,gBAAgB;EAChB,OAAO;EACP,UAAU;EACV,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;EAChB,YAAY;EACZ,mBAAmB;EACnB,gDAAgD;AAClD;;AAEA;EACE,kBAAkB;EAClB,gCAAgC;EAChC,eAAe;EACf,sBAAsB;EACtB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,4BAA4B;EAC5B,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;EAEE,gBAAgB;EAChB,OAAO;EACP,UAAU;EACV,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;EACnB,sBAAsB;EACtB,gDAAgD;EAChD,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;EACd,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA,mFAAmF;AACnF;EACE,oBAAoB;EACpB,4BAA4B;EAC5B,qBAAqB;EACrB,aAAa;EACb,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,sBAAsB;EACtB,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,YAAY;AACd;;AAEA;EACE,qBAAqB;EACrB,aAAa;AACf;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,eAAe;EACf,YAAY;AACd;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;EACf,YAAY;AACd;;AAEA;;;EAGE,eAAe;EACf,YAAY;AACd;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,qBAAqB;EACrB,eAAe;EACf,eAAe;EACf,YAAY;EACZ,iBAAiB;EACjB,eAAe;EACf,uBAAuB;AACzB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;;;;EAIE,0BAA0B;EAC1B,0BAA0B;EAC1B,8BAA8B;AAChC;;AAEA;EACE,cAAc;AAChB;;AAEA;;EAEE,cAAc;EACd,oBAAoB;EACpB,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,QAAQ;EACR,qBAAqB;EACrB,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,cAAc;EACd,eAAe;EACf,uBAAuB;AACzB;;AAEA;EACE,cAAc;EACd,0BAA0B;EAC1B,0BAA0B;EAC1B,8BAA8B;AAChC;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,gEAAgE;EAChE,kCAAkC;EAClC,gBAAgB;EAChB,eAAe;EACf,uBAAuB;AACzB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,qBAAqB;AACvB;;AAEA;;;;EAIE,cAAc;EACd,qBAAqB;AACvB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,gEAAgE;EAChE,eAAe;EACf,gBAAgB;EAChB,kCAAkC;EAClC,cAAc;AAChB;;AAEA;gDACgD;AAChD;EACE,mBAAmB;AACrB;;AAEA;;;EAGE,UAAU;EACV,YAAY;EACZ,eAAe;EACf,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;;EAEE,UAAU;EACV,mBAAmB;AACrB;;AAEA;;EAEE,UAAU;EACV,mBAAmB;AACrB;;AAEA;;EAEE,UAAU;EACV,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;;;;;;;;;;;;;;;;;;EAkBE,eAAe;AACjB;;AAEA;+DAC+D;AAC/D;EACE,mBAAmB;AACrB;;AAEA;;;EAGE,UAAU;EACV,YAAY;EACZ,eAAe;EACf,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;;;EAGE,UAAU;EACV,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;;EAEE,UAAU;EACV,mBAAmB;AACrB;;AAEA;;EAEE,UAAU;EACV,mBAAmB;AACrB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,cAAc;EACd,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,6BAA6B;AAC/B;;AAEA;;EAEE,mBAAmB;EACnB,kCAAkC;AACpC;;AAEA;;;;;EAKE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,gEAAgE;EAChE,eAAe;EACf,gBAAgB;EAChB,kCAAkC;EAClC,cAAc;AAChB;;AAEA;;gDAEgD;AAChD;;EAEE,cAAc;EACd,sBAAsB;AACxB;;AAEA;;EAEE,wBAAwB;EACxB,8BAA8B;EAC9B,yBAAyB;AAC3B;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,sBAAsB;EACtB,QAAQ;EACR,eAAe;EACf,gBAAgB;EAChB,kCAAkC;EAClC,cAAc;EACd,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,cAAc;EACd,YAAY;AACd;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;EACnB,6BAA6B;EAC7B,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,QAAQ;AACV;;AAEA;EACE,UAAU;EACV,WAAW;AACb;;AAEA;EACE,UAAU;EACV,WAAW;EACX,mBAAmB;EACnB,wBAAwB;EACxB,cAAc;EACd,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,UAAU;EACV,WAAW;AACb;;AAEA;EACE,oBAAoB;EACpB,QAAQ;EACR,mBAAmB;EACnB,yBAAyB;EACzB,eAAe;EACf,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,UAAU;AACZ;;AAEA,oEAAoE;AACpE;EACE,UAAU;EACV,QAAQ;AACV;;AAEA;EACE,gBAAgB;EAChB,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,yBAAyB;EACzB,gBAAgB;EAChB,cAAc;EACd,6BAA6B;EAC7B,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,mBAAmB;EACnB,eAAe;EACf,6DAA6D;AAC/D;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE;IACE,aAAa;EACf;AACF;;AAEA;EACE;IACE,aAAa;EACf;AACF;;AAEA;EACE,UAAU;EACV,kBAAkB;EAClB,cAAc;EACd,kBAAkB;EAClB,6BAA6B;AAC/B;;AAEA;EACE,oBAAoB;EACpB,sBAAsB;EACtB,uBAAuB;EACvB,gEAAgE;EAChE,eAAe;EACf,kCAAkC;EAClC,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,6BAA6B;EAC7B,mBAAmB;AACrB;;AAEA,iEAAiE;AACjE;EACE,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,6BAA6B;EAC7B,qBAAqB;EACrB,iBAAiB;EACjB,uBAAuB;AACzB;;AAEA;EACE,cAAc;EACd,0BAA0B;EAC1B,0BAA0B;AAC5B;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,eAAe;EACf,cAAc;EACd,6BAA6B;AAC/B;;AAEA;EACE,gBAAgB;AAClB","sourcesContent":["/* Matches incyia-ux-proposal.html table + sticky first column */\n.incyia-table-wrap {\n  overflow: auto;\n  width: 100%;\n  max-height: min(520px, calc(100vh - 340px));\n  overscroll-behavior: contain;\n}\n\n.incyia-table-wrap::-webkit-scrollbar {\n  width: 8px;\n  height: 8px;\n}\n\n.incyia-table-wrap::-webkit-scrollbar-thumb {\n  background: #c5d0d6;\n  border-radius: 99px;\n}\n\n.incyia-table-wrap::-webkit-scrollbar-track {\n  background: #f0f4f5;\n}\n\n.incyia-table {\n  width: 100%;\n  border-collapse: collapse;\n  white-space: nowrap;\n  font-family: Lato, sans-serif;\n}\n\n.incyia-table thead th {\n  font-size: 15px;\n  font-weight: 600;\n  letter-spacing: 0.12em;\n  text-transform: uppercase;\n  color: #8a9ba7;\n  text-align: left;\n  padding: 12px 16px;\n  background: #f7fafa;\n  border-bottom: 1px solid #dfe7e8;\n  position: sticky;\n  top: 0;\n  z-index: 2;\n}\n\n.incyia-table thead th:first-child {\n  position: sticky;\n  left: 0;\n  z-index: 4;\n  background: #f7fafa;\n  min-width: 160px;\n  max-width: 220px;\n  width: 220px;\n  white-space: nowrap;\n  box-shadow: 4px 0 8px -6px rgba(6, 21, 36, 0.25);\n}\n\n.incyia-table tbody td {\n  padding: 14px 16px;\n  border-bottom: 1px solid #eaf0f0;\n  font-size: 16px;\n  vertical-align: middle;\n  color: #0b1e2d;\n  background: #fff;\n}\n\n.incyia-table tbody tr {\n  transition: background 0.12s;\n  cursor: pointer;\n}\n\n.incyia-table tbody tr:hover {\n  background: #f7fafa;\n}\n\n.incyia-table tbody tr:hover td {\n  background: #f7fafa;\n}\n\n.incyia-table tbody tr:hover td:first-child {\n  background: #f7fafa;\n}\n\n.incyia-table tbody td:first-child,\n.incyia-table tbody td.incyia-col-pinned {\n  position: sticky;\n  left: 0;\n  z-index: 3;\n  background: #fff;\n  font-weight: 500;\n  min-width: 160px;\n  max-width: 220px;\n  width: 220px;\n  overflow: hidden;\n  white-space: normal;\n  word-break: break-word;\n  box-shadow: 4px 0 8px -6px rgba(6, 21, 36, 0.25);\n  cursor: pointer;\n}\n\n.incyia-table tbody tr:last-child td {\n  border-bottom: none;\n}\n\n.incyia-table td.incyia-wrap {\n  white-space: normal;\n  min-width: 200px;\n  max-width: 320px;\n  color: #5f7484;\n  line-height: 1.45;\n  vertical-align: middle;\n}\n\n/* Text preview — 2 lines, full text via title tooltip (Label, Description, etc.) */\n.incyia-desc {\n  display: -webkit-box;\n  -webkit-box-orient: vertical;\n  -webkit-line-clamp: 2;\n  line-clamp: 2;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: normal;\n  word-break: break-word;\n  max-width: 320px;\n  min-width: 0;\n  color: #5f7484;\n  font-size: 16px;\n  line-height: 1.45;\n  cursor: help;\n}\n\n.incyia-desc[data-lines='3'] {\n  -webkit-line-clamp: 3;\n  line-clamp: 3;\n}\n\n.incyia-desc.is-empty {\n  cursor: default;\n  color: #8a9ba7;\n}\n\n.incyia-desc--primary {\n  color: #0b1e2d;\n  font-weight: 500;\n  font-size: 16px;\n  line-height: 1.35;\n  max-width: 100%;\n  cursor: help;\n}\n\n.incyia-desc--primary.is-empty {\n  cursor: default;\n}\n\n.incyia-desc--sub {\n  color: #8a9ba7;\n  font-size: 15px;\n  font-weight: 400;\n  line-height: 1.35;\n  max-width: 100%;\n  cursor: help;\n}\n\n.incyia-col-pinned .incyia-desc,\n.incyia-wrap .incyia-desc,\n.incyia-muted .incyia-desc {\n  max-width: 100%;\n  min-width: 0;\n}\n\n.incyia-table td.incyia-muted {\n  color: #5f7484;\n  max-width: 220px;\n  white-space: normal;\n  vertical-align: middle;\n}\n\n.incyia-name-link {\n  color: #00146d;\n  font-weight: 500;\n  font-size: 16px;\n  text-decoration: none;\n  display: inline;\n  max-width: 100%;\n  min-width: 0;\n  line-height: 1.35;\n  cursor: pointer;\n  transition: color 0.14s;\n}\n\n.incyia-name-link:hover,\n.incyia-table tbody tr:hover .incyia-name-link {\n  color: #076b5c;\n}\n\n.incyia-name-link:hover .incyia-desc,\n.incyia-name-link:hover .incyia-desc--primary,\n.incyia-table tbody tr:hover .incyia-name-link .incyia-desc,\n.incyia-table tbody tr:hover .incyia-name-link .incyia-desc--primary {\n  text-decoration: underline;\n  text-underline-offset: 3px;\n  text-decoration-thickness: 1px;\n}\n\n.incyia-table tbody tr:hover .incyia-family-label .incyia-desc--primary {\n  color: #076b5c;\n}\n\n.incyia-name-link .incyia-desc,\n.incyia-name-link .incyia-desc--primary {\n  color: inherit;\n  font-weight: inherit;\n  font-size: inherit;\n  max-width: 100%;\n  width: fit-content;\n  cursor: pointer;\n  text-decoration: none;\n}\n\n.incyia-family-label {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: 2px;\n  text-decoration: none;\n  min-width: 0;\n  max-width: 100%;\n  overflow: hidden;\n  cursor: pointer;\n}\n\n.incyia-family-label .incyia-desc--primary {\n  text-decoration: none;\n  color: #00146d;\n  cursor: pointer;\n  transition: color 0.14s;\n}\n\n.incyia-family-label:hover .incyia-desc--primary {\n  color: #076b5c;\n  text-decoration: underline;\n  text-underline-offset: 3px;\n  text-decoration-thickness: 1px;\n}\n\n.incyia-family-code {\n  color: #0e8271;\n  font-weight: 500;\n  font-size: 17px;\n  font-family: 'IBM Plex Mono', ui-monospace, monospace !important;\n  font-variant-numeric: tabular-nums;\n  line-height: 1.2;\n  max-width: 100%;\n  letter-spacing: -0.01em;\n}\n\n.incyia-family-label .incyia-desc--sub {\n  color: #8b99b4;\n  font-size: 14.5px;\n  font-weight: 400;\n  margin-top: 2px;\n  text-decoration: none;\n}\n\n.incyia-family-label:hover .incyia-desc--sub,\n.incyia-table tbody tr:hover .incyia-family-label .incyia-desc--sub,\n.incyia-table tbody tr:hover .incyia-family-label .incyia-family-code,\n.incyia-family-label:hover .incyia-family-code {\n  color: #8b99b4;\n  text-decoration: none;\n}\n\n.incyia-table tbody tr:hover .incyia-family-label .incyia-family-code,\n.incyia-family-label:hover .incyia-family-code {\n  color: #0e8271;\n}\n\n.incyia-score {\n  font-family: 'IBM Plex Mono', ui-monospace, monospace !important;\n  font-size: 16px;\n  font-weight: 500;\n  font-variant-numeric: tabular-nums;\n  color: #0f172a;\n}\n\n/* Families list: four even lanes so Source is not stranded\n   in a gap and Score is not stuck to Actions. */\n.incyia-table--families {\n  table-layout: fixed;\n}\n\n.incyia-table--families thead th:first-child,\n.incyia-table--families tbody td:first-child,\n.incyia-table--families tbody td.incyia-col-pinned {\n  width: 44%;\n  min-width: 0;\n  max-width: none;\n  white-space: nowrap;\n  word-break: normal;\n  box-shadow: none;\n}\n\n.incyia-table--families th:nth-child(2),\n.incyia-table--families td:nth-child(2) {\n  width: 24%;\n  white-space: nowrap;\n}\n\n.incyia-table--families th:nth-child(3),\n.incyia-table--families td:nth-child(3) {\n  width: 18%;\n  white-space: nowrap;\n}\n\n.incyia-table--families th:nth-child(4),\n.incyia-table--families td:nth-child(4) {\n  width: 14%;\n  white-space: nowrap;\n}\n\n.incyia-family-name {\n  display: block;\n  max-width: 56ch;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  margin-top: 3px;\n  color: #5b6b87;\n  font-size: 16px;\n  font-weight: 400;\n  line-height: 1.35;\n}\n\n.incyia-family-source {\n  color: #5b6b87;\n  font-weight: 400;\n}\n\n.incyia-table--families .incyia-family-code,\n.incyia-table--families .incyia-family-name,\n.incyia-table--families .incyia-family-source,\n.incyia-table--families .incyia-score,\n.incyia-table--families .incyia-money,\n.incyia-table--families .incyia-desc,\n.incyia-table--families .incyia-desc--primary,\n.incyia-table--families .incyia-desc--sub,\n.incyia-table--families .mapping-flow-row-cta,\n.incyia-table--families .mapping-flow-row-cta-label,\n.incyia-table--controls .incyia-family-code,\n.incyia-table--controls .incyia-family-name,\n.incyia-table--controls .incyia-family-source,\n.incyia-table--controls .incyia-desc,\n.incyia-table--controls .incyia-desc--primary,\n.incyia-table--controls .incyia-desc--sub,\n.incyia-table--controls .mapping-flow-row-cta,\n.incyia-table--controls .mapping-flow-row-cta-label {\n  font-size: 16px;\n}\n\n/* Controls list: the description is the reading column.\n   The label stays a code plus one line, not a wrapped title. */\n.incyia-table--controls {\n  table-layout: fixed;\n}\n\n.incyia-table--controls thead th:first-child,\n.incyia-table--controls tbody td:first-child,\n.incyia-table--controls tbody td.incyia-col-pinned {\n  width: 26%;\n  min-width: 0;\n  max-width: none;\n  white-space: nowrap;\n  word-break: normal;\n  box-shadow: none;\n}\n\n.incyia-table--controls th:nth-child(2),\n.incyia-table--controls td:nth-child(2),\n.incyia-table--controls td.incyia-wrap {\n  width: 44%;\n  max-width: none;\n  white-space: normal;\n}\n\n.incyia-table--controls .incyia-desc {\n  max-width: none;\n  color: #5b6b87;\n}\n\n.incyia-table--controls th:nth-child(3),\n.incyia-table--controls td:nth-child(3) {\n  width: 14%;\n  white-space: nowrap;\n}\n\n.incyia-table--controls th:nth-child(4),\n.incyia-table--controls td:nth-child(4) {\n  width: 16%;\n  white-space: nowrap;\n}\n\n.incyia-table--controls .incyia-row-actions {\n  opacity: 1;\n}\n\n.incyia-table--families .incyia-row-actions {\n  opacity: 1;\n}\n\n.incyia-cell-sub {\n  display: block;\n  font-size: 15px;\n  color: #8a9ba7;\n  font-weight: 400;\n  margin-top: 1px;\n  line-height: 1.4;\n  white-space: normal;\n  font-family: Lato, sans-serif;\n}\n\n.incyia-money,\n.incyia-num {\n  white-space: nowrap;\n  font-variant-numeric: tabular-nums;\n}\n\ntd:has(> .incyia-money),\ntd:has(> .incyia-num),\ntd.incyia-num,\nth.incyia-num,\n.MuiDataGrid-cell.incyia-num {\n  text-align: left;\n  white-space: nowrap;\n}\n\nth.incyia-num > * {\n  justify-content: flex-start;\n}\n\n.incyia-money {\n  font-family: 'IBM Plex Mono', ui-monospace, monospace !important;\n  font-size: 16px;\n  font-weight: 500;\n  font-variant-numeric: tabular-nums;\n  color: #0f172a;\n}\n\n/* The date is the only thing in the cell. A normal line box keeps a\n   descender gap under the baseline, so the icon and the date sit high\n   in a short row and drop when the row grows. */\n.incyia-table tbody td:has(> .incyia-date-cell),\n.detail-table tbody td:has(> .incyia-date-cell) {\n  line-height: 0;\n  vertical-align: middle;\n}\n\n.MuiDataGrid-cell:has(> .incyia-date-cell),\n.detail-info-val:has(> .incyia-date-cell) {\n  display: flex !important;\n  align-items: center !important;\n  line-height: 1 !important;\n}\n\n.incyia-date-cell {\n  display: inline-flex;\n  align-items: center;\n  vertical-align: middle;\n  gap: 7px;\n  font-size: 16px;\n  font-weight: 500;\n  font-variant-numeric: tabular-nums;\n  color: #5b6b87;\n  white-space: nowrap;\n  line-height: 1;\n}\n\n.incyia-date-text {\n  display: block;\n  line-height: 1;\n}\n\n.incyia-date-cell[title] {\n  cursor: help;\n}\n\n.incyia-date-cell.is-empty {\n  color: #8a9ba7;\n}\n\n.incyia-date-cell svg {\n  display: block;\n  width: 14px;\n  height: 14px;\n  flex: 0 0 14px;\n  opacity: 0.6;\n}\n\n.incyia-pill {\n  display: inline-flex;\n  align-items: center;\n  gap: 5px;\n  font-size: 15px;\n  font-weight: 500;\n  padding: 3px 9px;\n  border-radius: 99px;\n  white-space: nowrap;\n  font-family: Lato, sans-serif;\n  line-height: 1;\n  vertical-align: middle;\n}\n\n.incyia-pill--sm {\n  font-size: 15px;\n  font-weight: 600;\n  padding: 2px 7px;\n  gap: 4px;\n}\n\n.incyia-pill--body {\n  font-size: 15px;\n  font-weight: 500;\n  padding: 5px 11px;\n  gap: 6px;\n}\n\n.incyia-pill--body .incyia-pill-dot {\n  width: 6px;\n  height: 6px;\n}\n\n.incyia-pill-dot {\n  width: 5px;\n  height: 5px;\n  border-radius: 99px;\n  background: currentColor;\n  flex-shrink: 0;\n  display: block;\n  align-self: center;\n}\n\n.incyia-pill--sm .incyia-pill-dot {\n  width: 4px;\n  height: 4px;\n}\n\n.incyia-row-actions {\n  display: inline-flex;\n  gap: 8px;\n  align-items: center;\n  justify-content: flex-end;\n  flex-wrap: wrap;\n  opacity: 0.55;\n  transition: opacity 0.14s;\n}\n\n.incyia-table tbody tr:hover .incyia-row-actions {\n  opacity: 1;\n}\n\n/* Labeled row CTAs — always readable (icons alone are not enough) */\n.incyia-row-actions--labeled {\n  opacity: 1;\n  gap: 6px;\n}\n\n.incyia-row-action-btn {\n  appearance: none;\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  height: 28px;\n  padding: 0 10px;\n  border-radius: 7px;\n  border: 1px solid #dfe7e8;\n  background: #fff;\n  color: #076b5c;\n  font-family: Lato, sans-serif;\n  font-size: 16px;\n  font-weight: 700;\n  letter-spacing: 0.01em;\n  white-space: nowrap;\n  cursor: pointer;\n  transition: background 0.14s, border-color 0.14s, color 0.14s;\n}\n\n.incyia-row-action-btn:hover {\n  background: #f0faf8;\n  border-color: #c5e4dc;\n  color: #055447;\n}\n\n.incyia-row-action-btn--ghost {\n  color: #5f7484;\n  font-weight: 600;\n}\n\n.incyia-row-action-btn--ghost:hover {\n  color: #0b1e2d;\n  background: #f7fafa;\n  border-color: #8a9ba7;\n}\n\n@media (max-width: 900px) {\n  .incyia-row-action-btn .incyia-row-action-full {\n    display: none;\n  }\n}\n\n@media (min-width: 901px) {\n  .incyia-row-action-btn .incyia-row-action-short {\n    display: none;\n  }\n}\n\n.incyia-table-empty {\n  padding: 0;\n  text-align: center;\n  color: inherit;\n  font-size: inherit;\n  font-family: Lato, sans-serif;\n}\n\n.incyia-sla {\n  display: inline-flex;\n  flex-direction: column;\n  align-items: flex-start;\n  font-family: 'IBM Plex Mono', ui-monospace, monospace !important;\n  font-size: 16px;\n  font-variant-numeric: tabular-nums;\n  color: #0b1e2d;\n  line-height: 1.15;\n}\n\n.incyia-sla-sub {\n  display: block;\n  font-size: 15px;\n  color: #8a9ba7;\n  font-weight: 400;\n  margin-top: 2px;\n  font-family: Lato, sans-serif;\n  white-space: nowrap;\n}\n\n/* Inline entity attach (pipeline / project) inside list tables */\n.entity-selector {\n  width: 100%;\n  min-width: 148px;\n  max-width: 220px;\n  position: relative;\n}\n\n.entity-selector-link {\n  display: inline;\n  max-width: 100%;\n  color: #00146d;\n  font-weight: 500;\n  font-size: 16px;\n  font-family: Lato, sans-serif;\n  text-decoration: none;\n  line-height: 1.35;\n  transition: color 0.14s;\n}\n\n.entity-selector-link:hover {\n  color: #076b5c;\n  text-decoration: underline;\n  text-underline-offset: 3px;\n}\n\n.entity-selector-loading {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  font-size: 16px;\n  color: #5f7484;\n  font-family: Lato, sans-serif;\n}\n\n.entity-select__menu {\n  min-width: 180px;\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
